import React, { useState } from "react";
import {
	Box,
	Button,
	Chip,
	Collapse,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

const BANNER_STORAGE_KEY = "wt_updates_banner_2026_10_14";

const highlights = [
	{
		icon: <BadgeOutlinedIcon sx={{ fontSize: 18 }} />,
		label: "Nome automático",
		detail: "IA usa o cadastro e salva o nome informado na conversa",
	},
	{
		icon: <SmartToyOutlinedIcon sx={{ fontSize: 18 }} />,
		label: "Agente de IA com memória",
		detail: "Atendimento personalizado de forma recorrente",
	},
	{
		icon: <AccessTimeOutlinedIcon sx={{ fontSize: 18 }} />,
		label: "Horário por fila",
		detail: "Prioridade do horário da fila; padrão só se não houver",
	},
	{
		icon: <ForumOutlinedIcon sx={{ fontSize: 18 }} />,
		label: "Chat interno + Chat Site",
		detail: "Grupos, visão admin e widget HTTPS",
	},
];

const SystemUpdatesBanner = () => {
	const [visible, setVisible] = useState(() => {
		try {
			return localStorage.getItem(BANNER_STORAGE_KEY) !== "dismissed";
		} catch {
			return true;
		}
	});

	const dismiss = () => {
		try {
			localStorage.setItem(BANNER_STORAGE_KEY, "dismissed");
		} catch {
			// ignore storage errors
		}
		setVisible(false);
	};

	return (
		<Collapse in={visible} unmountOnExit>
			<Box
				sx={{
					mx: { xs: 1.5, md: 2 },
					mt: 1.5,
					mb: 0.5,
					borderRadius: 2,
					overflow: "hidden",
					border: "1px solid",
					borderColor: "rgba(153, 0, 0, 0.22)",
					background:
						"linear-gradient(120deg, #1a0505 0%, #5c0000 42%, #990000 78%, #b91c1c 100%)",
					color: "#fff",
					boxShadow: "0 10px 28px rgba(153, 0, 0, 0.22)",
					position: "relative",
				}}
			>
				<Box
					sx={{
						position: "absolute",
						inset: 0,
						background:
							"radial-gradient(circle at 90% 10%, rgba(255,255,255,0.14), transparent 42%)",
						pointerEvents: "none",
					}}
				/>

				<Stack
					direction={{ xs: "column", md: "row" }}
					spacing={2}
					alignItems={{ xs: "stretch", md: "center" }}
					sx={{ p: { xs: 1.75, md: 2 }, position: "relative" }}
				>
					<Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ flex: 1, minWidth: 0 }}>
						<Box
							sx={{
								width: 42,
								height: 42,
								borderRadius: 1.5,
								display: "grid",
								placeItems: "center",
								bgcolor: "rgba(255,255,255,0.12)",
								border: "1px solid rgba(255,255,255,0.18)",
								flexShrink: 0,
							}}
						>
							<CampaignOutlinedIcon />
						</Box>

						<Box sx={{ minWidth: 0 }}>
							<Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
								<Chip
									size="small"
									icon={<WhatsAppIcon sx={{ color: "#fff !important", fontSize: "16px !important" }} />}
									label="Atualização — 14/10/2026"
									sx={{
										height: 24,
										bgcolor: "rgba(255,255,255,0.14)",
										color: "#fff",
										fontWeight: 700,
										"& .MuiChip-label": { px: 1 },
									}}
								/>
								<Typography variant="caption" sx={{ opacity: 0.85 }}>
									Multi Atendimento WhatsApp
								</Typography>
							</Stack>

							<Typography
								variant="subtitle1"
								sx={{ fontWeight: 800, mt: 0.75, lineHeight: 1.25 }}
							>
								Atualizações de hoje: IA, filas e horário de atendimento
							</Typography>

							<Typography variant="body2" sx={{ mt: 0.5, opacity: 0.92, maxWidth: 820 }}>
								A IA agora tem memória para atendimento personalizado recorrente,
								reconhece contatos cadastrados e pode salvar o nome informado na
								conversa. O horário próprio da fila passa a ter prioridade sobre o
								horário padrão do sistema.
							</Typography>

							<Stack
								direction="row"
								spacing={1}
								useFlexGap
								flexWrap="wrap"
								sx={{ mt: 1.25 }}
							>
								{highlights.map(item => (
									<Chip
										key={item.label}
										size="small"
										icon={item.icon}
										label={`${item.label}: ${item.detail}`}
										sx={{
											maxWidth: "100%",
											height: "auto",
											py: 0.5,
											bgcolor: "rgba(0,0,0,0.22)",
											color: "#fff",
											border: "1px solid rgba(255,255,255,0.16)",
											"& .MuiChip-icon": { color: "#fff", ml: 0.75 },
											"& .MuiChip-label": {
												whiteSpace: "normal",
												py: 0.25,
												lineHeight: 1.25,
											},
										}}
									/>
								))}
							</Stack>
						</Box>
					</Stack>

					<Stack
						direction="row"
						spacing={1}
						alignItems="center"
						justifyContent={{ xs: "flex-end", md: "center" }}
						sx={{ flexShrink: 0 }}
					>
						<Button
							variant="contained"
							onClick={dismiss}
							sx={{
								bgcolor: "#fff",
								color: "#7f1d1d",
								fontWeight: 700,
								textTransform: "none",
								boxShadow: "none",
								"&:hover": { bgcolor: "#f8fafc" },
							}}
						>
							Entendi
						</Button>
						<IconButton
							aria-label="Fechar banner"
							onClick={dismiss}
							sx={{ color: "rgba(255,255,255,0.85)" }}
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					</Stack>
				</Stack>
			</Box>
		</Collapse>
	);
};

export default SystemUpdatesBanner;
